<template>
  <div class="mypage-payment-edit-pane">
    <external-confirmation-section
      :title="$tc('MypagePage.common.externalConfirmation.title.web')"
      :message="$tc('MypagePage.common.externalConfirmation.message.web')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import ExternalConfirmationSection from '@/components/common/ExternalConfirmation/ExternalConfirmationSection.vue'

/**
 * アプリ版: クレジットカード情報変更ペイン
 */
export default defineComponent({
  name: 'MypagePaymentEditPane',
  components: {
    ExternalConfirmationSection,
  },
})
</script>

<style lang="scss" scoped>
.mypage-payment-edit-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{env(safe-area-inset-bottom)});
  padding: 24px 0 104px;
  margin: 0 auto;
  text-align: left;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
